import React from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";

import RoundButton from "../RoundButton";

import { DialogStyles, DialogButton, CloseButton, ButtonText } from "./styles";

import button_close from "../../assets/buttons/btn_fechar.svg";
import theme from "../../theme";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const useStyles = makeStyles({
  Dialog: {},
  DialogTitle: {
    background: theme.palette.background.main,
    color: theme.palette.primary.main,
    display: "flex",
    padding: theme.spacing(2),
    "@media(min-width: 900px)": {
      padding: theme.spacing(3),
    },
  },
  DialogTitleContent: {
    flexGrow: "1",
    display: "flex",
    alignItems: "center",
    color: theme.palette.primary.main,
    h6: {
      lineHeight: 1.1,
    },
  },
  DialogContent: {
    padding: theme.spacing(2),
    color: "#000",
    maxHeight: "60vh",
    overflow: "auto",
    "@media(min-width: 900px)": {
      padding: theme.spacing(3),
    },
  },
  Divider: {
    background: `${theme.palette.primary.main} !important`,
    height: "2px",
  },
});

export default function (props) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const {
    content,
    title,
    image,
    clicked,
    help,
    buttonText,
    colorText,
    colorBackground,
    colorBackgroundHover,
    p11
  } = props;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DialogStyles>
      {buttonText ? (
        <ButtonText
          variant='body1'
          className=''
          onClick={handleClickOpen}
          clicked={clicked}
          colorText={colorText}
          colorBackground={colorBackground}
          colorBackgroundHover={colorBackgroundHover}
        >
          <Typography variant='body1'>
            {buttonText}
          </Typography>
        </ButtonText>
      ) : help ? (
        <RoundButton
          tooltip='Ajuda'
          type='help'
          onClick={handleClickOpen}
          margin
        />
      ) : (
        <DialogButton
          onClick={handleClickOpen}
          clicked={clicked}
          colorBackground={colorBackground}
          colorBackgroundHover={colorBackgroundHover}
          p11={p11}
        >
          <img src={image} alt={title} />
        </DialogButton>
      )}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
        maxWidth='md'
        className={classes.Dialog}
      >
        <Box id='alert-dialog-slide-title' className={classes.DialogTitle}>
          <Box className={classes.DialogTitleContent}>
            <Typography variant='h6'>{title}</Typography>
          </Box>
          <CloseButton onClick={handleClose}>
            <img src={button_close} alt='Fechar' />
          </CloseButton>
        </Box>
        <Box className={classes.Divider} />
        <DialogContent className={classes.DialogContent}>
          <DialogContentText
            id='alert-dialog-slide-description'
            className={classes.DialogContentText}
          >
            {content}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </DialogStyles>
  );
}
